/**
 * Which watchlist the Earnings surfaces are bound to.
 *
 * Deliberately its own preference, separate from the Dashboard's: the
 * Dashboard list is usually everything you hold, while the earnings list is
 * the handful you care about reporting. Switching one must not move the other.
 *
 * Shared so the company page reached from Earnings targets the same list the
 * user was just looking at — bookmarking there and finding the company absent
 * on the way back reads as a broken button.
 */
export const EARNINGS_STORAGE_KEY = "insight:earnings-watchlist-id";

/**
 * First run only. Users migrated off the old standalone earnings watchlist get
 * a list of this name, so landing on it is what they expect. Once they choose
 * something else the stored id wins, and renaming this list changes nothing.
 */
export const EARNINGS_PREFERRED_WATCHLIST_NAME = "Earnings";

/**
 * Whether the Earnings hub shows every list ("All watchlists") instead of the
 * one above. Its own flag, so the stored list id stays a real list: the
 * company page bookmarks into it whatever the hub is showing.
 */
export const EARNINGS_ALL_STORAGE_KEY = "insight:earnings-all-watchlists";
